import { render, staticRenderFns } from "./CourseScheduleDetailsComponent.vue?vue&type=template&id=6d4f4590&"
import script from "./CourseScheduleDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./CourseScheduleDetailsComponent.vue?vue&type=script&lang=js&"
import style0 from "./CourseScheduleDetailsComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ifrond/srv/civana/reset/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d4f4590')) {
      api.createRecord('6d4f4590', component.options)
    } else {
      api.reload('6d4f4590', component.options)
    }
    module.hot.accept("./CourseScheduleDetailsComponent.vue?vue&type=template&id=6d4f4590&", function () {
      api.rerender('6d4f4590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin/components/CourseScheduleDetailsComponent.vue"
export default component.exports